import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
} from "reactstrap";

import React from "react";
import FIELDS, { MEDIA_FIELDS, MASTER_FIELDS } from "./CONSTANT";
import ChooseImage from "../../../components/ChooseImage";
import { FieldInput } from "../../../components/FieldInput";

export default function MasterForm({ validation }) {
  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row>
              {MASTER_FIELDS.map((f) => (
                <FieldInput key={f.key} f={f} validation={validation} />
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
